module.exports = __webpack_public_path__ + "img/complaint.7565af43.svg";